<template>
  <v-row justify="center">
    <v-col class="text-center pt-5" cols="12" sm="10" md="8" lg="6">
      <v-card outlined class="pa-10">
        <p class="display-1">スポーツ教材提供申請エラー</p>
        <p>
          申請処理中にエラーが発生しました。大変申し訳ございませんが、再度申請をお願い申し上げます。
          <br />申請ができない場合には、事務局までお問い合わせください。
        </p>
        <p class="mb-10">
          公益財団法人ヤマハ発動機スポーツ振興財団 事務局
          <br />
          <v-icon>mdi-phone</v-icon>0538-32-9827（担当：濱北）
        </p>
        <v-btn class="primary" to="/">申請トップフォームへ戻る</v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "KyoikuInputError"
};
</script>